import ProductCard from "../ProductCard/ProductCard";
import EmptyState from "../EmptyState/EmptyState";

export default function ProductGrid({ products }) {
 if (!products.length)
  return (
   <EmptyState
    title="No products found"
    description="Try another search term or category filter."
   />
 );
 return (
  <div className="grid gap-x-5 gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
   {products.map((product) => (
    <ProductCard key={product.id} product={product} />
   ))}
  </div>
 );
}
